import { EntityClaimRakurakuHistory } from "../../entity/EntityClaimRakurakuHistory";

export class DtoClaimRakurakuHistorysPutRes extends EntityClaimRakurakuHistory {}
